const COMPANY_LINKS = [
  { name: "HostPepper", url: "https://hostpepper.com" },
  { name: "Hakker.Ai", url: "https://hakker.ai" },
  { name: "Hakk.Ai", url: "https://hakk.ai" },
  { name: "GaonTek", url: "https://gaontek.com" },
  { name: "Teknyq", url: "https://teknyq.com" },
  { name: "Omega Sector Security", url: "https://omegasectorsecurity.com" },
  { name: "Techy Bootcamp", url: "https://techybootcamp.com" },
  { name: "Intl Couriers", url: "https://intlcouriers.com" },
  { name: "Clear Beaches", url: "https://clearbeaches.org" },
];

export default function Footer() {
  return (
    <footer className="relative bg-secondary-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-heading font-bold text-lg">
                AH
              </span>
              <div>
                <div className="font-heading text-lg font-bold">Alon Hahamy</div>
                <div className="text-xs text-background-100/70">
                  Technology executive · Networks · Security · IoT
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm md:text-base text-background-100/75 leading-relaxed max-w-md">
              30+ years designing, securing and scaling the technology that critical
              organizations depend on every day.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <a
                href="mailto:alon@alonhahamy.com"
                aria-label="Email"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-900 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label="LinkedIn"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-900 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://x.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label="X"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-900 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://github.com/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                aria-label="GitHub"
                className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-900 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer"
              >
                <i className="ri-github-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-widest text-primary-400 font-semibold mb-4">
              Companies & Ventures
            </div>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
              {COMPANY_LINKS.map((c) => (
                <li key={c.url}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="text-background-100/80 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-primary-400 font-semibold mb-4">
              Navigate
            </div>
            <ul className="space-y-2 text-sm">
              {[
                { l: "About", h: "#about" },
                { l: "Expertise", h: "#expertise" },
                { l: "Ventures", h: "#ventures" },
                { l: "Clients", h: "#clients" },
                { l: "Industries", h: "#industries" },
                { l: "Contact", h: "#contact" },
              ].map((n) => (
                <li key={n.h}>
                  <a
                    href={n.h}
                    className="text-background-100/80 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {n.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 border-t border-secondary-900 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs md:text-sm text-background-100/60">
            © {new Date().getFullYear()} Alon Hahamy. All rights reserved.
          </div>
          <div className="text-xs md:text-sm text-background-100/50 font-mono">
            alonhahamy.com
          </div>
        </div>
      </div>
    </footer>
  );
}